<template>
  <div class="comments-show-more">
    <div class="comments-show-more__progress-wrap">
      <span class="comments-show-more__progress-text">{{ $t('review.seen1') + ' ' + comments.comments.length + ' ' + $t('review.seen2') + ' ' + comments.total_count + ' ' + computedType }}</span>
      <div class="comments-show-more__progress">
        <div class="comments-show-more__progress--active" :style="{'width': comments.comments.length * 100 / comments.total_count + '%'}"></div>
      </div>
    </div>
    <Button
      v-if="comments.comments_left"
      @click.native="fetchMoreComments"
      :is-native-disabled="isLoading"
      size="plain"
      class="comments-show-more__show-more"
    >
      {{ $t('show_more') }} {{ comments.comments_left > 10 ? 10 : comments.comments_left }}
    </Button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Button from '../inputs/Button'

export default {
  name: 'CommentsShowMore',
  components: {
    Button
  },
  props: {
    isQuestions: {
      type: Boolean,
      default: false
    },
    comments: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    getCommentsEndpoint: {
      type: String,
      required: true
    },
    productId: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    computedType () {
      return this.isQuestions ? this.$t('questions.questions') : this.$t('review.seen3')
    }
  },
  methods: {
    ...mapActions('comments', ['FETCH_COMMENTS']),
    ...mapActions('questions', ['FETCH_QUESTIONS']),
    fetchMoreComments () {
      const params = {
        offset: this.comments.offset,
        endpoint: this.getCommentsEndpoint
      }

      if (this.productId) params['id'] = this.productId
      if (this.isQuestions) {
        this.FETCH_QUESTIONS(params)
      } else {
        this.FETCH_COMMENTS(params)
      }
    }
  }
}
</script>

<style scoped lang="sass">

.comments-show-more__progress-wrap
  display: block
  width: max-content
  margin: 40px auto
  overflow: hidden

.comments-show-more__progress
  position: relative
  width: 200px
  height: 2px
  background-color: #e7e7e7

  &--active
    position: absolute
    left: 0
    top: 0
    bottom: 0
    background-color: $main-color

.comments-show-more__progress-text
  display: block
  margin-bottom: 20px
  font-size: 14px
  color: $placeholder-color
  text-align: center

.comments-show-more__show-more
  margin: 0 auto

</style>
